// src/components/ChatApp.js
import React, { useEffect, useState } from 'react';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';
import styled from 'styled-components';
import axios from '../axiosConfig';
import ConversationDetail from './ConversationDetail';
import ConversationList from './ConversationList';
import Sidebar from './Sidebar';

const ChatApp = () => {
  const [conversations, setConversations] = useState([]);
  const [selectedConversation, setSelectedConversation] = useState(null);

  const fetchConversations = async () => {
    try {
      const response = await axios.get('/list/conversations');
      setConversations(response.data);
      console.log("Updating app...");
    } catch (err) {
      console.error('Failed to fetch conversations', err);
    }
  };

  useEffect(() => {
    fetchConversations();

    // Polling for updates every 30 seconds
    const intervalId = setInterval(fetchConversations, 30000);    

    // Cleanup function to stop polling on unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleConversationClick = (conversation) => {
    console.log("Selected conversation", conversation);
    setSelectedConversation(conversation);
  };

  return (
    
    <Container>
      <Sidebar />
      <ConversationList
        conversations={conversations}
        onConversationClick={handleConversationClick}
      />
      {selectedConversation && (
        <ConversationDetailContainer>
          <BackButton >
            <MdOutlineKeyboardBackspace onClick={() => {setSelectedConversation(null)}} className='backIcon'/> {selectedConversation.client_name} <div></div>
            </BackButton>
          <ConversationDetail initialConversation={selectedConversation} fetchConversations={fetchConversations}/>
        </ConversationDetailContainer>
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  @media screen and (max-width: 600px) {
   flex-direction: column;
  }
`;


const ConversationDetailContainer = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
    @media screen and (max-width: 600px) {
    position: absolute;
    height: 100%;
  }
`;

const BackButton = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 20px;
  font-size: 3vh;
  color: white;
  padding: 5px 10px;
  background-color: #2c2c2c;
`;


export default ChatApp;
